import Pagination from './Pagination'
import CustomInput from './CustomInput'
import CustomTextarea from './CustomTextarea'
import FormItem from './FormItem'
import MultipleSelect from './MultipleSelect'
import Scroll from './Scroll'
import ReachBottomScroll from './ReachBottomScroll'
import ReachBottomHandler from './ReachBottomHandler'
import VideoPlayer from './VideoPlayer'
import FooterBottom from './FooterBottom'
import ScrollLoading from './ScrollLoading'
import NoMore from './NoMore'
import Ellipsis from './Ellipsis'
import BackTop from './BackTop'

export default {
    install(Vue){
        Vue.component('pagination', Pagination)
        Vue.component('custom-input', CustomInput)
        Vue.component('custom-textarea', CustomTextarea)
        Vue.component('form-item', FormItem)
        Vue.component('multiple-select', MultipleSelect)
        Vue.component('scroll', Scroll)
        Vue.component('ReachBottomScroll', ReachBottomScroll)
        Vue.component('ReachBottomHandler', ReachBottomHandler)
        Vue.component('FooterBottom', FooterBottom)
        Vue.component('ScrollLoading', ScrollLoading)
        Vue.component('NoMore', NoMore)
        Vue.component('Ellipsis', Ellipsis)
        Vue.component('BackTop', BackTop)
    }
}


// WEBPACK FOOTER //
// ./src/components/index.js